module.exports = __webpack_public_path__ + "static/media/pg.e3c208b9.svg";